import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Store } from "@ngrx/store";

@Component({
	selector: "config-module-container",
	templateUrl: "./config-module-container.component.html"
})
export class ConfigModuleContainerComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
